export default __webpack_public_path__ + "static/media/BackgroundMusic.008fe577.mp3";